import React from "react";
import { Card, Col, Row, Table } from "antd";
import { formatNumber } from "../../../util/NumberFormatter";
import MobileStatBox from "../../common/MobileStatBox";
import useIsMobile from "../../../util/useIsMobile";

function CharacterCell({ characterName, bestWeapon }) {
  const characterImgSrc = `/img/character/${characterName}.png`;
  const weaponImgSrc = `/img/weapon_skill/${bestWeapon}.png`;

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      textAlign: 'left'
    }}>
      <div style={{
        position: 'relative',
        width: '36px',
        height: '36px',
        marginRight: '8px',
        flexShrink: 0
      }}>
        <div style={{
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          backgroundColor: '#d6d6d6',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <img
            src={characterImgSrc}
            alt={characterName}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
        <img
          src={weaponImgSrc}
          alt={bestWeapon}
          style={{
            position: 'absolute',
            bottom: '0px',
            right: '-8px',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            backgroundColor: '#323232',
            padding: '2px',
            border: '1px solid #4A4A4A'
          }}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      </div>
      <span style={{ whiteSpace: 'nowrap' }}>
        {characterName} [{bestWeapon}]
      </span>
    </div>
  );
}

function StatByCharacterMobileCard({ stat }) {
  return (
    <Card size="small" style={{ marginBottom: 8 }} bodyStyle={{ padding: 10 }}>
      <div style={{ marginBottom: 4 }}>
        <CharacterCell characterName={stat.characterName} bestWeapon={stat.bestWeapon} />
      </div>
      <div style={{ fontSize: 12, color: '#888', marginBottom: 6 }}>{stat.nickname}</div>
      <Row gutter={[4, 4]}>
        <Col span={8}><MobileStatBox label="총 데미지" value={formatNumber(stat.damage)} /></Col>
        <Col span={8}>
          <MobileStatBox
            label="게임 수"
            value={`${stat.size} (${Math.floor(stat.totalTime / 60)}분 ${stat.totalTime % 60}초)`}
          />
        </Col>
        <Col span={8}>
          <MobileStatBox
            label="게임당 데미지[dps]"
            value={`${formatNumber(Math.floor(stat.damage / stat.size))} [${(stat.damage / stat.totalTime).toFixed(2)}]`}
          />
        </Col>
      </Row>
    </Card>
  );
}

export default function StatByCharacter({ data, loading }) {
  const isMobile = useIsMobile();

  const columns = [
    {
      title: '플레이어',
      dataIndex: 'nickname',
      align: 'center',
      sorter: (a, b) => (a.nickname || '').localeCompare(b.nickname || '')
    },
    {
      title: '실험체',
      align: 'left',
      render: (stat) => (
        <CharacterCell characterName={stat.characterName} bestWeapon={stat.bestWeapon} />
      ),
      sorter: (a, b) => (a.characterName || '').localeCompare(b.characterName || '')
    },
    {
      title: '총 데미지',
      dataIndex: 'damage',
      align: 'center',
      sorter: (a, b) => a.damage - b.damage,
      render: (damage) => formatNumber(damage)
    },
    {
      title: '게임 수',
      dataIndex: 'size',
      align: 'center',
      sorter: (a, b) => a.size - b.size,
      render: (size, record) => (
        <span>
          <div>{size}</div>
          <div style={{ fontSize: '0.77em' }}>
            ({Math.floor(record.totalTime / 60)}분 {record.totalTime % 60}초)
          </div>
        </span>
      )
    },
    {
      title: '게임 당 데미지 [dps]',
      align: 'center',
      sorter: (a, b) => (a.damage / a.size) - (b.damage / b.size),
      render: (stat) => (
        <span>
          <div>{formatNumber(Math.floor(stat.damage / stat.size))}</div>
          <div style={{ fontSize: '0.77em' }}>
            [{(stat.damage / stat.totalTime).toFixed(2)}]
          </div>
        </span>
      )
    }
  ];

  if (isMobile) {
    return (
      <div>
        {data.map((stat) => (
          <StatByCharacterMobileCard
            key={`${stat.nickname}-${stat.characterName}-${stat.bestWeapon}`}
            stat={stat}
          />
        ))}
      </div>
    );
  }

  return (
    <Table
      className='table-wrapper-with-border'
      pagination={false}
      dataSource={data}
      columns={columns}
      loading={loading}
      rowKey={(record) => `${record.nickname}-${record.characterName}-${record.bestWeapon}`}
      scroll={{ x: 'max-content' }}
    />
  );
}
